import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import ProgressBar from '../ProgressBar';
import Spinner from '../Spinner';
import LabelStageNames from '../LabelStageNames';
import types from '../../types';
import userWhite from '../../assets/User-white.svg';
import styles from './styles.module.scss';

const PageTitle = ({
                     nextStep,
                     currentUserStepNumber,
                     totalSteps,
                     firstName,
                     specificStep
                   }) => {
  const nextSpecificStep = specificStep.nextStep;
  const currentUserSpecificStepNumber = specificStep.currentUserStepNumber;
  const totalSpecificSteps = specificStep.totalSteps;

  const viewCurrentStepNumber = Boolean(currentUserSpecificStepNumber)
    ? (currentUserSpecificStepNumber - 1) || 1
    : (currentUserStepNumber - 1) || 1;
  const viewNextStep = Boolean(nextSpecificStep) ? nextSpecificStep : nextStep;
  const viewTotalSteps = Boolean(totalSpecificSteps) ? totalSpecificSteps : totalSteps;

  if (nextStep === 100 || nextSpecificStep === 100) return null;
  if (Boolean(!viewCurrentStepNumber) || Boolean(!viewTotalSteps)) return <Spinner/>;

  const title = (
    <FormattedMessage id={`step${viewNextStep}.page.title`}/>
  );
  const subtitle = (
    <FormattedMessage id={`step${viewNextStep}.page.subtitle`}/>
  );
  const stepInfo = (
    <FormattedMessage
      id={`common.page.step.info`}
      defaultMessage={'out of {total}'}
      values={{
        total: viewTotalSteps
      }}
    />
  );
  const stepName = (
    <FormattedMessage id={`step${viewNextStep}.page.name`}/>
  );

  const viewProgress = currentUserSpecificStepNumber
    ? Math.ceil(100 * currentUserSpecificStepNumber / (totalSpecificSteps))
    : Math.ceil(100 * currentUserStepNumber / (totalSteps));

  return (
    <div className={styles.asideContainer}>
      {firstName && (
        <div className={styles.usernameContainer}>
          <img src={userWhite} alt="user" className={styles.userpic}/>
          <div className={styles.username}>
            <FormattedMessage
              id="common-hello-label"
              defaultMessage="Hello, {username}"
              values={{username: firstName}}
            />
          </div>
        </div>
      )}
      <div className={styles.titleContainer}>
        <div className={styles.progressBarContainer}>
          <ProgressBar radius={46} stroke={4} progress={viewProgress}/>
          <div className={styles.progressBarLabels}>
            <div className={styles.progressBarStep}>{viewCurrentStepNumber}</div>
            <div className={styles.progressBarStepSmall}>{stepInfo}</div>
          </div>
        </div>
        <div className={styles.labelsContainer}>
          <div className={styles.subTitle}>{subtitle}</div>
          <div className={styles.title}>{title}</div>
          {
            (viewNextStep >= 7 && viewNextStep <= 15) && (
              <div className={styles.name}>{stepName}</div>
            )
          }
        </div>
      </div>
      <LabelStageNames/>
    </div>
  )
};

PageTitle.propTypes = {
  ...types.router,
  nextStep: PropTypes.number,
  currentUserStepNumber: PropTypes.number,
  totalSteps: PropTypes.number,
  firstName: PropTypes.string,
};

export default PageTitle;
